<template>
  <div>
    <wc-data-box
      title='Contact'
      :titleIcon='$store.state.icons.modules.clients.icon'
      :titleIconColor='$store.state.icons.modules.clients.color'
      showEdit
      @edit='edit'
    >
      <wc-two-column-table :items='contactData'></wc-two-column-table>
    </wc-data-box>

    <wc-dialog
      :showDialog='showDialog'
      :loadingButtons='isLoading'
      :disableButtons='!isFormValid'
      title='Contact'
      :icon='$store.state.icons.modules.clients.icon'
      width='400'
      @cancel='showDialog = false'
      @save='save'
    >
      <v-form v-model='isFormValid'>
        <v-text-field
          label='First Name'
          v-model='inquiryCopy.name'
          :rules='[rules.required]'
        ></v-text-field>
        <v-text-field
          label='Last Name'
          v-model='inquiryCopy.last_name'
        ></v-text-field>
        <v-text-field
          prepend-icon='mdi-email'
          label='Email'
          v-model='inquiryCopy.email'
          :rules='[rules.email]'
        ></v-text-field>
        <v-text-field
          prepend-icon='mdi-cellphone'
          label='Cell Phone'
          v-model='inquiryCopy.cell_phone'
          :rules='[rules.phoneNumber]'
        ></v-text-field>
      </v-form>
    </wc-dialog>

  </div>
</template>

<script>
import _ from 'lodash'
import formRules from '@/mixins/formRules'

export default {
  name: 'inquiry-contact',
  mixins: [formRules],
  data: () => ({
    showDialog: false,
    isFormValid: false,
    isLoading: false,
    saving: false,
    inquiryCopy: {}
  }),
  props: {
    inquiry: {
      required: true
    }
  },
  computed: {
    contactData () {
      let data = []
      if (this.inquiry) {
        data = [
          { text: 'Name', value: this.inquiry.name + ' ' + this.inquiry.last_name },
          { text: 'Email', value: this.inquiry.email },
          { text: 'Cell Phone', value: this.inquiry.cell_phone }
        ]
      }
      return data
    }
  },
  methods: {
    edit () {
      this.inquiryCopy = _.cloneDeep(this.inquiry)
      this.showDialog = true
    },
    save () {
      this.$emit('update', this.inquiryCopy)
      this.showDialog = false
    }
  }
}
</script>
